/**
 * Einheitliche Rückmeldung für Aufgaben, deren Prüfung diese PowerPoint-Version
 * nicht hergibt.
 *
 * Die Angaben, die der Kurs prüft, stammen aus sehr unterschiedlichen
 * Anforderungssätzen – die Platzhalterart etwa erst ab PowerPointApi 1.8,
 * Alternativtexte ab 1.10. Statt in solchen Fällen zu raten oder die Aufgabe
 * still als bestanden zu werten, sagt der Kurs offen, was fehlt und warum.
 */

import { unsupported } from "@/core/check";
import type { CheckResult } from "@/core/types";

/**
 * @param angabe   Was nicht gelesen werden kann, aus Sicht der lernenden Person.
 * @param abSatz   Ab welchem Anforderungssatz die Angabe zur Verfügung steht.
 * @param selbst   Wie sich die Aufgabe ohne Prüfung selbst kontrollieren lässt.
 */
export function nichtPruefbar(angabe: string, abSatz: string, selbst: string): CheckResult {
  return unsupported(
    `${angabe} – diese Angabe lässt sich erst ab dem Anforderungssatz PowerPointApi ` +
      `${abSatz} auslesen. Diese PowerPoint-Version stellt sie nicht bereit, deshalb kann ` +
      "die Aufgabe hier nicht automatisch geprüft werden.",
    `${selbst} Danach kannst du den Schritt selbst als erledigt markieren.`,
  );
}
